import { useState } from 'react';
import { MlRow } from './SafeTickets';

const LEAGUES = [['nfl', 'NFL'], ['cfb', 'College'], ['nba', 'NBA']];

// Who wins every game, with the spread (sportsbook style on the shared link).
export default function WhoWins({ data }) {
  const avail = LEAGUES.filter(([k]) => data[k]?.wins?.length);
  const [tab, setTab] = useState(avail[0]?.[0] || 'nfl');
  const [all, setAll] = useState(false);
  if (!avail.length) return null;
  const wins = [...(data[tab]?.wins || [])].sort((a, b) => b.prob - a.prob);
  const shown = all ? wins : wins.slice(0, 10);
  return (
    <div className="rounded-xl border border-emerald-500/30 bg-zinc-900/70 p-3" data-testid="who-wins">
      <p className="text-sm font-bold text-white">Who wins: spreads for every game</p>
      <p className="text-[11px] text-zinc-500 mb-2">Our pick to win each game, the spread, and the win chance (sportsbook + ESPN power rating).</p>
      <div className="flex gap-2 mb-1">
        {avail.map(([k, l]) => (
          <button key={k} type="button" onClick={() => { setTab(k); setAll(false); }} data-testid={`who-wins-tab-${k}`}
            className={`rounded-full border px-3 py-1 text-xs font-semibold ${tab === k ? 'bg-emerald-500 border-emerald-500 text-black' : 'border-zinc-700 text-zinc-400 hover:text-white'}`}>{l} ({data[k].wins.length})</button>
        ))}
      </div>
      {shown.map((x, i) => <MlRow key={`${x.key}-${x.team}-${i}`} x={x} testId={`who-wins-${tab}-${i}`} />)}
      {wins.length > 10 && (
        <button type="button" onClick={() => setAll((a) => !a)} data-testid="who-wins-more" className="mt-1 text-xs font-semibold text-emerald-300">
          {all ? 'Show top 10' : `Show all ${wins.length} games`}
        </button>
      )}
    </div>
  );
}
